<template>
  <div class="filter-section flex-clz">
    <div class="input-box-container">
      <el-row gutter="10">
        <el-col :span="8" v-for="(item, index) in inputConfigs" :key="index" v-show="isExpanded || index < 2">
          <el-form-item :label="item.label">
            <el-input v-model="item.value" :placeholder="inputPlaceholder"></el-input>
          </el-form-item>
          <!-- 鍦ㄧ粍浠跺唴閮ㄦ柊澧炰竴涓绠楀睘鎬ф垨鑰呮暟鎹睘鎬ф潵瀛樻斁鍗犱綅绗﹀唴瀹?-->
          <span v-if="!inputPlaceholder">{{ setPlaceholder(item.label) }}</span>
        </el-col>
      </el-row>
    </div>
    <el-button type="text" @click="toggleInputBoxes" :icon="isExpanded? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
      {{ isExpanded? '收起' : '展开' }}
    </el-button>
    <div class="flex button-clz"><el-button type="primary" :icon="Search" @click="initUserList">搜索</el-button></div>
  </div>

  <div class=" flex-clz">
    <div class="flex button-clz"><el-button type="primary" :icon="Download" @click="initUserList">导出</el-button></div>
    <el-table :data="tableData" stripe border style="width: 100%">
    <el-table-column prop="participatingUnit" label="参建单位" align="center"/>
    <el-table-column prop="role" label="角色" align="center"/>
    <el-table-column prop="entryExitStatus" label="进退场状态" align="center"/>
    <el-table-column prop="contractType" label="承包类型" align="center"/>
    <el-table-column prop="enterprisePersonInCharge" label="企业负责人" align="center"/>
    <el-table-column prop="contactNumber" label="负责人联系电话" align="center"/>
      <el-table-column prop="action" label="操作"  fixed="right" align="center">
        <template #default="scope">
          <a  >查看详情</a>
        </template>
      </el-table-column>
    </el-table>
    </div>
  <div>
    <Pagination ref="childComponentRef" @data-sent="handleData" :apiUrl="myApiUrl" :searchParams="searchParams"></Pagination>
  </div>
</template>

<script setup>
import {Search, Download, Tools} from "@element-plus/icons-vue";
import {ref, reactive, onMounted} from 'vue';
import Pagination from "@/views/common/Pagination.vue";

// 响应式数据
const isExpanded = ref(false); // 用于控制是否展开的状态，初始设为展开
const inputConfigs = reactive([
  { label: "参建单位", value: "" },
  { label: "角色", value: "" },
  { label: "进退场状态", value: "" },
]);
const tableData = reactive([

]);
const inputPlaceholder = ref("");

// 方法定义
const toggleInputBoxes = () => {
  isExpanded.value =!isExpanded.value;
};

const setPlaceholder = (label) => {
  inputPlaceholder.value = `请输入${label}`;
  return inputPlaceholder.value;
};

const initUserList = () => {
  console.log('这里需要根据具体功能完善initUserList方法逻辑');
};

const viewDetails = (project) => {
  console.log('这里需要完善查看详情的具体逻辑，比如跳转到详情页等', project);
};

</script>

<style scoped>

</style>